import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class WaterHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.isValidMove = false;
    this.type = "water";

    this.build();
  }

  build() {
    super.build();

    // this tile is transparent, the visuals comme from OpenWater
  }

  test() {
    // There's nothing to test as we can see the water already
    app.audio.play(app.data.global.sounds.blocked_tile, 1.0, true);
  }

  hit() {
    // Add a little delay because we trigger the hit as soon as we move
    setTimeout(() => {
      app.audio.play(app.data.global.sounds.splash_water, 1.0, true);
      app.audio.play(app.data.global.sounds.obstacle, 1.0, true);
    }, app.game.player.playerMovementDuration);
  }

  show() {

  }

  endOfTurnAction() {

  }

  endGame() {
    app.game.endGame();
    app.animateOutGame(10);
  }

  // Reset the states so we can animate in again and start over
  reset() {

  }


}
